import { SyncEventType } from '../../enums/syncEventType';
import { Issue } from '../../issue';
import { PersistenceEvent } from './persistenceEvent';

export class EventIssueUpdated implements PersistenceEvent {

  public readonly type = SyncEventType.ISSUE_UPDATED;
  public issue: Issue;
  public sprintId: number;

  constructor(issue: Issue, sprintId?: number) {
    this.issue = issue;
    this.sprintId = sprintId;
  }

  getPayload(): object {
    const payload = {
      'issue': this.issue,
      'sprintId': this.sprintId
    };
    return payload;
  }

  static fromPayload(payload: any): EventIssueUpdated {
    return new EventIssueUpdated(
      payload['issue'], payload['sprintId']
    );
  }

}

